import { RequestBuilder } from "@lernetz/request";
import { writable } from "svelte/store";
import { trimLeft } from "./path";
import { router, type GotoConfig } from "./router";

export function historyMode(basePath?: string) {
  const base = new RequestBuilder(basePath || window.location.href);
  const location = writable({ path: "", query: undefined, hash: undefined });

  const onPopState = () => {
    let { path, config } = readURL();
    router.goto(path, config);
  };

  const generateURL = (p: string, config: GotoConfig) => {
    let r = base.relative(p);
    if (config.query) r = r.query(config.query);
    if (config.hash) r = r.hash(config.hash);
    return r.url;
  };

  const writeURL = (p: string, config: GotoConfig) => {
    let currentURL = window.location.href;
    let newURL = generateURL(p, config);
    let mode = config.replace ? "replaceState" : "pushState";

    // only push if current path is different
    if (newURL != currentURL) {
      history[mode]({}, "", newURL);
    }
  };

  const readURL = (): { path: string; config: GotoConfig } => {
    const currentURL = new URL(window.location.href);
    const baseURL = new URL(base.url);
    const hash = currentURL.hash?.startsWith("#") ? currentURL.hash.slice(1) : undefined;

    return {
      path: trimLeft(baseURL.pathname, currentURL.pathname),
      config: {
        query: currentURL.searchParams,
        hash,
        scroll: {
          target: hash ? "anchor" : undefined,
        },
      },
    };
  };

  window.addEventListener("popstate", onPopState);
  const destroy = () => window.removeEventListener("popstate", onPopState);

  router.setMode({
    generateURL,
    writeURL,
    readURL,
    destroy,
  });

  let current = readURL();
  router.goto(current.path, {
    ...current.config,
    scroll: current.config.hash ? { target: "anchor" } : undefined,
  });
}
